<template>
  <transition name="esocial-modal-fade">
    <div class="esocial-modal-overlay" v-if="showFormEdit" @click.self="close">
      <div class="esocial-modal esocial-modal--wide">
        <div class="esocial-modal__header">
          <span class="esocial-modal__title">Gerar Novo Lote</span>
          <button class="esocial-modal__close" @click="close">
            <i class="fa fa-times"></i>
          </button>
        </div>

        <div class="esocial-modal__body" v-loading="config.loading.content">
          <ed-alert class="mb-3">
            <div slot="description">
              O sistema já faz esta verificação diariamente e cria os lotes necessários. Use esse formulário só se
              quiser forçar a geração agora, para uma empresa/layout específico.
            </div>
          </ed-alert>

          <div class="gerar-lote-section">
            <div class="gerar-lote-section__title">Obrigatório</div>

            <ed-form :model="formData">
              <ed-input-auto-complete
                class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pa-0"
                label="Empresa"
                placeholder="Pesquisar empresa"
                v-model="formData.id_emp"
                :items="config.list.id_emp"
                :loading="config.loading.id_emp"
                @search="getEmpresa"
                clearable
                required
              />
              <ed-input-auto-complete
                class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pa-0"
                label="Layout"
                placeholder="Pesquisar layout"
                v-model="formData.layout"
                :items="config.list.layout"
                :loading="config.loading.layout"
                itemText="esocial"
                @search="getLayout"
                is-object
                clearable
                required
              />
            </ed-form>
          </div>

          <div class="gerar-lote-section">
            <button class="gerar-lote-section__toggle" @click="showFiltros = !showFiltros">
              <i class="fa" :class="showFiltros ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
              Filtros opcionais
              <span class="gerar-lote-section__badge" v-if="totalFiltrosAtivos">{{ totalFiltrosAtivos }}</span>
            </button>

            <ed-form :model="formData" v-if="showFiltros">
              <ed-input-auto-complete
                class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pa-0"
                label="Frente de Trabalho"
                v-model="formData.fdts"
                :items="config.list.id_fdt"
                :loading="config.loading.id_fdt"
                @search="getFdt"
                :disabled="!formData.id_emp || !formData.layout"
                itemText="fdt"
                clearable
                multiple
              />

              <ed-input-auto-complete
                class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pa-0"
                label="Funcionário"
                v-model="formData.funcionarios"
                :items="config.list.id_fun"
                :loading="config.loading.id_fun"
                :disabled="!formData.id_emp || !formData.layout"
                @search="getFuncionario"
                clearable
                multiple
              />

              <ed-input-date
                class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"
                label="Data de cadastro do arquivo"
                type="daterange"
                v-model="formData.created_at"
                :disabled="!formData.id_emp || !formData.layout"
              />

              <ed-input-auto-complete
                class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pa-0"
                label="Não incluir os seguintes funcionários"
                v-model="formData.funcionarios_delete"
                :items="config.list.id_fun"
                :loading="config.loading.id_fun"
                :disabled="!formData.id_emp || !formData.layout"
                @search="getFuncionario"
                clearable
                multiple
              />

              <ed-input-select
                class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pa-0"
                label="Somente eventos avulsos"
                v-model="formData.avulso"
                :items="[{ id: 1, nome: 'Sim' }, { id: 0, nome: 'Não' }]"
                :disabled="!formData.id_emp || !formData.layout"
                clearable
              />
            </ed-form>
          </div>

          <div class="gerar-lote-resultado" v-if="resultado">
            <div class="gerar-lote-resultado__icon" :class="resultado.total_lotes ? 'is-success' : 'is-empty'">
              <i class="fa" :class="resultado.total_lotes ? 'fa-check-circle' : 'fa-info-circle'"></i>
            </div>
            <div class="gerar-lote-resultado__content">
              <b v-if="resultado.total_lotes">
                {{ resultado.total_lotes }} lote(s) gerado(s) com {{ resultado.total_eventos }} evento(s).
              </b>
              <b v-else>Nenhum lote gerado.</b>
              <span v-if="resultado.msg">{{ resultado.msg }}</span>
            </div>
          </div>
        </div>

        <div class="esocial-modal__footer">
          <button class="esocial-modal__btn esocial-modal__btn--primary" :disabled="config.loading.save" @click="salvar">
            <i class="fa fa-spinner fa-spin" v-if="config.loading.save"></i>
            Gerar Lote
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Rest from "common/rest";

import { EdForm, EdAlert, EdInputAutoComplete, EdInputSelect, EdInputDate } from "template";

export default {
  name: "esocial-lotes-gerar",
  mixins: [Rest],
  components: {
    EdForm,
    EdAlert,
    EdInputAutoComplete,
    EdInputSelect,
    EdInputDate,
  },
  props: {
    parent: {
      type: Object,
      default: function () {
        return {};
      },
    },
    showForm: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
  },
  watch: {
    showForm() {
      this.showFormEdit = this.showForm;

      if (this.showFormEdit) {
        this.resultado = null;
      }
    },
    "formData.id_emp"() {
      this.getFdt();
      this.getFuncionario();
    },
  },

  computed: {
    totalFiltrosAtivos() {
      var f = this.formData;
      var total = 0;

      if (f.fdts && f.fdts.length) total++;
      if (f.funcionarios && f.funcionarios.length) total++;
      if (f.funcionarios_delete && f.funcionarios_delete.length) total++;
      if (f.created_at && f.created_at.length) total++;
      if (f.avulso) total++;

      return total;
    },
  },

  data() {
    return {
      config: {
        loading: {
          save: false,
          content: false,
          id_emp: false,
          layout: false,
          id_fdt: false,
          id_fun: false,
        },
        list: {
          id_emp: [],
          layout: [],
          id_fdt: [],
          id_fun: [],
        },
      },
      resultado: null,
      showFiltros: false,
      formData: {
        id_emp: null,
        layout: null,
        avulso: 0,
        created_at: [],
        fdts: [],
        funcionarios: [],
        funcionarios_delete: [],
      },
      showFormEdit: false,
    };
  },

  mounted() {
    this.getLayout();
    this.getEmpresa();
  },

  methods: {
    close() {
      this.showFormEdit = false;

      if (this.parent.showFormEdit) {
        this.parent.showFormEdit = false;
      }
    },

    getEmpresa: function (_search) {
      this.config.loading.id_emp = true;
      this.config.list.id_emp = [];

      this.get("/empresa", { search: _search }).then((result) => {
        result = result[0];
        this.config.loading.id_emp = false;

        if (result.status == 200) {
          this.config.list.id_emp = result.data.data;
        }
      });
    },

    getFdt: function (_search) {
      if (!this.formData.id_emp) return;

      this.config.loading.id_fdt = true;
      this.config.list.id_fdt = [];

      this.get("pcmso/fdt/" + this.formData.id_emp, { search: _search }).then((result) => {
        result = result[0];
        this.config.loading.id_fdt = false;

        if (result.status == 200) {
          this.config.list.id_fdt = result.data.data;
        }
      });
    },

    getFuncionario: function (_search) {
      if (!this.formData.id_emp) return;

      this.config.loading.id_fun = true;
      this.config.list.id_fun = [];

      this.get("/empresa/funcionario/" + this.formData.id_emp, {
        search: _search,
      }).then((result) => {
        result = result[0];

        this.config.loading.id_fun = false;

        if (result.status == 200) {
          this.config.list.id_fun = result.data.data;
        }
      });
    },
    getLayout: function (_search) {
      this.config.loading.layout = true;
      this.config.list.layout = [];

      this.get("esocial/tabelas/conteudo/9", { search: _search }).then((result) => {
        result = result[0];

        this.config.loading.layout = false;

        if (result.status == 200) {
          this.config.list.layout = result.data.data;
        }
      });
    },

    salvar() {
      if (!this.formData.id_emp || !this.formData.layout) {
        this.edAlert("Selecione a empresa e o layout", "error");
        return;
      }

      this.$confirm(
        "O sistema já faz esta verificação diariamente automaticamente e cria os lotes necessários. Deseja verificar agora se existem novos lotes?",
        "Atenção",
        {
          type: "warning",
        }
      ).then(() => {
        this.config.loading.save = true;
        this.resultado = null;

        var filter = {
          id_empresa: this.formData.id_emp,
          created_at: this.formData.created_at,
          fdts: this.formData.fdts,
          funcionarios: this.formData.funcionarios,
          funcionarios_delete: this.formData.funcionarios_delete,
          avulso: this.formData.avulso,
        };

        this.get("esocial/lotes/gerar/" + this.formData.layout.codigo, {
          filter: filter,
        }).then((result) => {
          this.config.loading.save = false;

          result = result[0];

          if (result.status == 200) {
            this.resultado = result.data || { total_lotes: 0, total_eventos: 0 };

            if (this.parent.getEsocialLotes) this.parent.getEsocialLotes(this.parent.search);

            if (this.resultado.total_lotes) {
              this.edAlert(
                "Processo de cadastro do LOTE iniciado em segundo plano. Aguarde alguns instantes e acesse eSocial > Lotes para acompanhar o processo."
              );
            }
          } else {
            this.edAlert(result.msg, "error");
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.esocial-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1500;
}

.esocial-modal {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);
  width: 620px;
  max-width: 92vw;
  max-height: 85vh;
  overflow: hidden;

  &--wide {
    width: 90%;
    max-width: 980px;
  }
}

.esocial-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  border-bottom: 3px solid rgba(168, 121, 31, 0.45);
}

.esocial-modal__title {
  font-size: 15px;
  font-weight: 700;
  color: #1f2329;
}

.esocial-modal__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: #f1f2f4;
  color: #6b7280;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s;

  &:hover {
    background: #e4e7ed;
    color: #1f2329;
  }
}

.esocial-modal__body {
  padding: 20px 22px;
  overflow-y: auto;
  flex: 1 1 auto;
}

.esocial-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 22px;
  border-top: 1px solid #eef0f2;
}

.esocial-modal__btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 34px;
  padding: 0 16px;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;

  &--primary {
    background: #09f;
    color: #fff;

    &:hover {
      background: #0087dd;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}

.esocial-modal-fade-enter-active,
.esocial-modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.esocial-modal-fade-enter,
.esocial-modal-fade-leave-to {
  opacity: 0;
}

.gerar-lote-section {
  margin-bottom: 18px;
  padding-bottom: 14px;
  border-bottom: 1px solid #eef0f2;

  &:last-of-type {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
}

.gerar-lote-section__title {
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}

.gerar-lote-section__toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 0;
  border: none;
  background: none;
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  cursor: pointer;
  margin-bottom: 10px;

  &:hover {
    color: #1f2329;
  }

  i {
    font-size: 10px;
  }
}

.gerar-lote-section__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  height: 16px;
  padding: 0 5px;
  border-radius: 999px;
  background: #09f;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  text-transform: none;
  letter-spacing: 0;
}

.gerar-lote-resultado {
  display: flex;
  gap: 12px;
  margin-top: 16px;
  padding: 14px 16px;
  border-radius: 10px;
  background: #f7f9fb;
  border: 1px solid #eef0f2;
}

.gerar-lote-resultado__icon {
  font-size: 20px;
  flex: 0 0 auto;

  &.is-success {
    color: #1a8a3e;
  }

  &.is-empty {
    color: #a5812c;
  }
}

.gerar-lote-resultado__content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: #1f2329;

  span {
    color: #6b7280;
    font-size: 11px;
    line-height: 1.4;
  }
}
</style>



// WEBPACK FOOTER //
// gerar.vue?16859300